/**
 * Initialise un bloc latest-* côté frontend.
 *
 * @param {Object} config
 * @param {string} config.containerSelector   - Sélecteur CSS du conteneur (ex: '.wp-block-welko-latest-offres')
 * @param {string} config.blockPrefix         - Préfixe CSS du bloc (ex: 'wp-block-welko-latest-offres')
 * @param {string} config.ajaxActionFilter    - Nom de l'action AJAX pour le filtre
 * @param {string} config.ajaxActionLoadmore  - Nom de l'action AJAX pour le loadmore
 */
export function initLatestCPTBlock(config) {
	const { containerSelector, blockPrefix, ajaxActionFilter, ajaxActionLoadmore } = config;
	const ajax_url = ajaxurl['ajax_url'];

	window.addEventListener('DOMContentLoaded', () => {
		const containers = document.querySelectorAll(containerSelector);
		containers.forEach((container) => {
			initTermFilterEvents(container, blockPrefix, ajaxActionFilter, ajax_url);
			initLoadmoreEvents(container, blockPrefix, ajaxActionLoadmore, ajax_url);
			initSwiper(container, blockPrefix);
		});
	});
}

// --- SWIPER ---

function initSwiper(container, blockPrefix) {
	const swiper = container.querySelector(`.${blockPrefix}__list .swiper`);
	if (!swiper) return;

	const swiperName = '.swiper_' + swiper.getAttribute('data-id');
	const nbSlide = parseInt(swiper.getAttribute('data-nb-slide'));
	const autoSlide = (/true/).test(swiper.getAttribute('data-auto-slide'));
	const infiniteSlide = (/true/).test(swiper.parentElement.getAttribute('data-infinite_slide'));
	const hasNavigation = (/true/).test(swiper.parentElement.getAttribute('data-navigation'));
	const hasPagination = (/true/).test(swiper.parentElement.getAttribute('data-pagination'));
	const slidesCount = swiper.querySelectorAll('.swiper-slide').length;

	// console.log('------------------------');
	// console.log(blockPrefix);
	// console.log(hasNavigation);
	// console.log(hasPagination);
	// console.log(slidesCount);
	// console.log('------------------------');

	new Swiper(swiperName, {
		watchSlidesProgress: true,
		spaceBetween: 30,
		loop: infiniteSlide,
		slidesPerView: 1,
		autoplay: autoSlide ? {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		} : false,
		breakpoints: {
			0: { slidesPerView: 1 },
			577: { slidesPerView: 2 },
			767: { slidesPerView: 3 },
			992: { slidesPerView: Math.min(nbSlide, slidesCount) },
		},
		navigation: hasNavigation ? {
			nextEl: swiperName + ' .swiper-button-next',
			prevEl: swiperName + ' .swiper-button-prev',
		} : false,
		pagination: hasPagination ? {
			el: swiperName + ' .swiper-pagination',
			clickable: true,
		} : false,
	});
}

// --- LOADMORE ---

function initLoadmoreEvents(container, blockPrefix, ajaxAction, ajaxUrl) {
	const loadmores = container.querySelectorAll(`.${blockPrefix}__loadmore`);
	const postListContainer = container.querySelector(`.${blockPrefix}__list`);
	if (loadmores.length > 0 && postListContainer) {
		loadmores.forEach((loadmore) => {
			loadmore.addEventListener('click', () => {
				doLoadmore(postListContainer, blockPrefix, ajaxAction, ajaxUrl);
			});
		});
	}
}

function doLoadmore(postListContainer, blockPrefix, ajaxAction, ajaxUrl) {
	const postLoadmore = postListContainer.nextElementSibling?.classList.contains(`${blockPrefix}__loadmore`)
		? postListContainer.nextElementSibling
		: false;

	const _data = {
		action: ajaxAction,
		...postListContainer.dataset,
	};

	fetch(ajaxUrl, {
		method: 'POST',
		body: new URLSearchParams(_data).toString(),
		headers: { 'Content-type': 'application/x-www-form-urlencoded' },
	})
		.then((response) => {
			if (!response.ok) throw new Error('Erreur réseau');
			return response.json();
		})
		.then((data) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(data.html, 'text/html');
			Array.from(doc.body.children).forEach((el) => {
				postListContainer.append(el);
			});

			const postsPerPage = postListContainer.getAttribute('data-posts_per_page');
			const offset = postListContainer.getAttribute('data-offset');
			const newOffset = parseInt(offset) + parseInt(postsPerPage);
			postListContainer.setAttribute('data-offset', newOffset);

			const postCount = postListContainer.getAttribute('data-post_count');
			if (parseInt(newOffset) >= parseInt(postCount) && postLoadmore) {
				postLoadmore.style.display = 'none';
			}
		});
}

// --- TERM FILTER ---

function initTermFilterEvents(container, blockPrefix, ajaxAction, ajaxUrl) {
	const filters = container.querySelectorAll(`.${blockPrefix}__filters__filter`);
	const postListContainer = container.querySelector(`.${blockPrefix}__list`);
	const selectFilter = container.querySelector(`.${blockPrefix}__filters select`);

	// Select dropdown
	if (selectFilter && postListContainer) {
		selectFilter.addEventListener('change', () => {
			const selectedOption = selectFilter.options[selectFilter.selectedIndex];
			const termId = selectedOption.getAttribute('data-termid');
			doTermFilter(termId, postListContainer, blockPrefix, ajaxAction, ajaxUrl, container);
		});
	}

	// Boutons UL
	if (filters.length > 0 && postListContainer) {
		filters.forEach((filter) => {
			filter.addEventListener('click', () => {
				const termId = filter.getAttribute('data-termid');
				doTermFilter(termId, postListContainer, blockPrefix, ajaxAction, ajaxUrl, container);
				const activeFilter = container.querySelector(`.${blockPrefix}__filters__filter--active`);
				if (activeFilter) activeFilter.classList.remove(`${blockPrefix}__filters__filter--active`);
				filter.classList.add(`${blockPrefix}__filters__filter--active`);
			});
		});
	}
}

function doTermFilter(termIdClicked, postListContainer, blockPrefix, ajaxAction, ajaxUrl, container) {
	const termId = termIdClicked != null ? termIdClicked : '';
	
	// Récupération des catégories qui sont sélectionnées dans le filtre. Si il y en a pas on indique une chaine vide
	let selectedTermsId = container.querySelector(`.${blockPrefix}__list`).getAttribute('data-terms_id');
	selectedTermsId = selectedTermsId != null ?selectedTermsId : '';

	console.log(postListContainer.dataset);
	postListContainer.style.opacity = '0';

	const postLoadmore = postListContainer.getAttribute('data-display_loadmore') === 'loadmore'
		? postListContainer.nextElementSibling
		: false;
	if (postLoadmore) postLoadmore.style.opacity = '0';

	const _data = {
		action: ajaxAction,
		...postListContainer.dataset,
		terms_id: termId,
		selected_terms_id: selectedTermsId
	};

	fetch(ajaxUrl, {
		method: 'POST',
		body: new URLSearchParams(_data).toString(),
		headers: { 'Content-type': 'application/x-www-form-urlencoded' },
	})
		.then((response) => {
			if (!response.ok) throw new Error('Erreur réseau');
			return response.json();
		})
		.then((data) => {
			postListContainer.innerHTML = data.html;
			postListContainer.style.opacity = '1';

			if (postListContainer.getAttribute('data-layout') === 'slider') {
				initSwiper(container, blockPrefix);
			}

			const postsPerPage = postListContainer.getAttribute('data-posts_per_page');
			postListContainer.setAttribute('data-offset', postsPerPage);

			const offset = parseInt(postsPerPage);
			const count = parseInt(data.count);

			if (postLoadmore && count > offset) {
				postLoadmore.style.display = 'flex';
				postLoadmore.style.opacity = '1';
			}

			postListContainer.setAttribute('data-terms_id', termId);
			postListContainer.setAttribute('data-post_count', count);
		});
}
